<button #buttonLeft *ngIf="currentScroll > 0" class="button-left" (click)="scrollTo('left')">
  <i class="app-icon-arrow-left"></i>
</button>
<div #container class="container">
  <ng-content></ng-content>
</div>
<button #buttonRight *ngIf="currentScroll < maxScroll" class="button-right" (click)="scrollTo('right')">
  <i class="app-icon-arrow-right"></i>
</button>
